const executiveMembers = [
  {
    id: 1,
    name: "Prof. V. Venkata Basava Rao",
    designation: "Chairman",
    info: "Hon'ble Vice-Chancellor, Rayalaseema University, Kurnool",
    hierarchy: 1
  },
  {
    id: 2,
    name: "Principal Secretary, Higher Education",
    designation: "Member",
    info: "Secretary to Government , Dept. of Higher Education, Govt. of A.P., Secretariat, Velagapudi",
    hierarchy: 2
  },
  {
    id: 3,
    name: "Chirman,APSCHE",
    designation: "Member",
    info: "Chairman, Andhra Pradesh State Council of Higher Education (APSCHE), Mangalagiri, Guntur",
    hierarchy: 2
  },
  {
    id: 4,
    name: "Commissioner of Higher Education",
    designation: "Member",
    info: "Commissioner of Higher Education, Govt. of Andhra Pradesh",
    hierarchy: 2
  },
  {
    id: 5,
    name: "Nominee from Principal Secretary (Finance)",
    designation: "Member",
    info: "Finance Department, Govt. of Andhra Pradesh, Secretariat, Velagapudi",
    hierarchy: 2
  },
 
  {
    id: 11,
    name: "Prof. B. Vijaya Kumar Naidu",
    designation: "Member Secretary",
    info: "Registrar, Rayalaseema University, Kurnool",
    hierarchy: 4
  }
];

export default executiveMembers;
